<template lang="pug">
    .page
        .ctl-bar
            a-button(type="primary" @click="getData") 刷新
        a-table(:columns="columns" 
            :dataSource="items" 
            size="small"
            bordered
            :loading="loading"
            :scroll="computedScroll"
            :pagination="{pageSize: 50}"
            rowKey="_id")
        //- z-table(:columns="columns" 
        //-     :strictRoute="`hkoption/${bookName}/summary`"   
        //-     :addAble="false"      
        //-     :deleteAble="false"
        //-     :editAble="false"  
        //-     :pageSize="15" 
        //-     size="small")
</template>

<script>
export default {
    props: ['bookName'],
    data() {
        return {
            items: [],
            loading: false,
            columns: [
                {
                    title: 'Stock Code',
                    dataIndex: 'stock_code',
                    searchAble: true,
                    fixed: 'left',
                    width: 85,
                },
                {
                    title: 'Stock Name',
                    dataIndex: 'stock_name',
                    searchAble: true,
                    fixed: 'left',
                    width: 80,
                },
                {
                    title: 'Hedging Gain Loss',
                    dataIndex: 'hedging_gain_loss',
                    type: 'Number'
                },
                {
                    title: 'Total Daily Pnl',
                    dataIndex: 'total_daily_pnl',
                },
                {
                    title: 'Total Pnl',
                    dataIndex: 'total_pnl',
                },
                {
                    title: 'Option Mark Up',
                    dataIndex: 'option_mark_up',
                    width: 80,
                },
                {
                    title: 'Option Daily Pnl',
                    dataIndex: 'option_daily_pnl',
                },
                {
                    title: 'Option Pnl',
                    dataIndex: 'option_pnl',
                },
                {
                    title: 'Instrinsic Value',
                    dataIndex: 'instrinsic_value',
                },
                {
                    title: 'Stock Daily Pnl',
                    dataIndex: 'stock_daily_pnl',
                },
                {
                    title: 'Cumulative Stock Pnl',
                    dataIndex: 'cumulative_stock_pnl',
                    width: 110,
                },
                {
                    title: 'Time Value',
                    dataIndex: 'time_value',
                },
                {
                    title: 'Notional',
                    dataIndex: 'notional',
                    width: 80,
                    
                },
                {
                    title: 'Delta',
                    dataIndex: 'delta',
                },
                {
                    title: 'Delta Pnl',
                    dataIndex: 'delta_pnl',
                },
                {
                    title: 'Theta',
                    dataIndex: 'theta',
                },
                {
                    title: 'Theta Pnl',
                    dataIndex: 'theta_pnl',
                },
                
                {
                    title: 'Gamma',
                    dataIndex: 'gamma',
                },
                {
                    title: 'Gamma Pnl',
                    dataIndex: 'gamma_pnl',
                },
                {
                    title: 'Vega',
                    dataIndex: 'vega',
                },
                {
                    title: 'Rho',
                    dataIndex: 'rho',
                },
            ]
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            this.$api.request('GET', `hkoption/${this.bookName}/summary`, {})
            .then(res => {
                this.loading = false;
                this.items = res.data;
            })
        }
    },
    computed: {
        computedScroll() {
            let pageHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
            let isMac = /mac os/ig.test(navigator.userAgent);

            if (isMac) {
                return { x: Math.max(100*this.columns.length, 1200)}
            }
            else {
                return { x: Math.max(100*this.columns.length, 1200), y: pageHeight*0.7 }
            }

            
        },
    }
}
</script>